//
// Generated class SeasonStartLog
//

/// <reference path="SeasonStartLog_ManagedObject.ts" />

class SeasonStartLog extends SeasonStartLog_ManagedObject
{

}
